import { OutsideClick } from '@semcore/base-components';
import type { OutsideClickProps } from '@semcore/base-components';
export {
  /**
   * @deprecated Use OutsideClick from `@semcore/base-components` instead. Package `@semcore/outside-click` will be removed in the next major release
   */
  OutsideClick,
  /**
   * @deprecated Use OutsideClickProps from `@semcore/base-components` instead. Package `@semcore/outside-click` will be removed in the next major release
   */
  type OutsideClickProps,
};
/**
 * @deprecated Use OutsideClick from `@semcore/base-components` instead. Package `@semcore/outside-click` will be removed in the next major release
 */
export default OutsideClick;
